import { gql } from '@apollo/client';

export interface ReportFlavorSharesResponse {
  allRpFlavorDecomps: {
    nodes: {
      referenceFlavor: string;
      decomp: string | number | null;
      version: string | null;
      product: { name: string } | null;
    }[];
  };
}

/** Every product's reference flavor decomp shares (0–1), for every version of a report. */
export default gql`
  query ReportFlavorSharesQuery($reportId: UUID!) {
    allRpFlavorDecomps(condition: { reportId: $reportId }) {
      nodes {
        referenceFlavor
        decomp
        version
        product: productByProductId {
          name
        }
      }
    }
  }
`;
